<script lang="ts">
  import Header from '$components/shared/Header.svelte';
  import Footer from '$components/shared/Footer.svelte';
  import MobileTabBar from '$components/shared/MobileTabBar.svelte';
  import BetaBanner from '$components/BetaBanner.svelte';
  import type { Snippet } from 'svelte';

  let { children }: { children: Snippet } = $props();
</script>

<div class="app-layout">
  <BetaBanner />
  <Header />
  <main class="container main-content">
    {@render children()}
  </main>
  <Footer />
  <MobileTabBar />
</div>

<style>
  .app-layout {
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
  }
  .main-content {
    flex: 1;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  /* Space for fixed bottom tab bar on mobile */
  @media (max-width: 767px) {
    .main-content {
      padding-bottom: 4.5rem;
    }
  }
</style>
